import { FormMapping } from '@app/utils/form-mapping/decorators/form-mapping';
import { IntInput } from '@app/utils/form-mapping/helpers/default-attributes';
import { FormMappingModel } from '@app/utils/form-mapping/models/form-mapping-model';

@FormMapping()
export class PaginationForm extends FormMappingModel {
  @IntInput
  page: number;

  @IntInput
  pageSize: number;
}
